import axios from 'axios';
import Cookies from 'js-cookie';

const BASE_URL_BE = process.env.REACT_APP_BASE_URL_BE;

const getAuthToken = () => Cookies.get('access_token');

const getAuthHeaders = () => ({
  'Authorization': `Bearer ${getAuthToken()}`
});

// services/kategoriService.js
export const fetchProvinsi = async (params = {}) => {
  try {
    const defaultParams = {
      disable_pagination: true,
      ...params
    };

    const queryParams = new URLSearchParams();
    
    Object.entries(defaultParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        queryParams.append(key, value);
      }
    });

    const response = await axios.get(`${BASE_URL_BE}/provinsi?${queryParams.toString()}`, {
      headers: getAuthHeaders()
    });
    
    return {
      success: true,
      data: response.data.data,
      meta: response.data.meta || {}
    };
  } catch (error) {
    console.error("Error fetching kategori:", error);
    return {
      success: false,
      message: error.response?.data?.message || "Gagal memuat data kategori",
      error: error.response?.data || error.message
    };
  }
};

